import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import { useEffectOnce } from 'usehooks-ts';

import { insuranceTemplatesFetch } from './action';
import { selectFeatureInsuranceTemplate } from './selector';

export const useInsuranceTemplatesFetch = () => {
  const dispatch = useDispatch();
  const { templates } = useSelector(selectFeatureInsuranceTemplate);

  useEffectOnce(() => {
    if (!isEmpty(templates)) return;
    dispatch(insuranceTemplatesFetch());
  });

  return templates;
};
